const styles = {
  container: {
    marginTop: '.25em',
    marginBottom: '.25em',
  },
};

export default styles;
